// extracted by mini-css-extract-plugin
module.exports = {"buttonPadding":"LoginButton_buttonPadding__NK5iD","loginText":"LoginButton_loginText__HvADt","link":"LoginButton_link__YMTGQ"};